import { Pipe, PipeTransform } from "@angular/core";
import { isNullOrUndefined } from "@syncfusion/ej2-base";
import { CommonMethods } from "@services/common.method";
import { CodeTypes } from "../enums/code-types.enum";

@Pipe({ name: "primarytechnician" })
export class PrimaryTechnicianPipe implements PipeTransform {
  constructor(public commonMethods: CommonMethods) { }
  isNull(value)
    { 
    if(isNullOrUndefined(value)) { return "";}
    else return value;
    }
  transform(data: any): Object {
    if (data.length > 0) {
      let appointmentTypes = this.commonMethods.getCodeTypeData(CodeTypes.AppointmentType);
      let technicianCodeTypeId = appointmentTypes.find(x=> x.Code == 'PrimaryTech').ID;
      if (data.find(x => x.AppointmentTypeID == technicianCodeTypeId) != undefined) {       
        let primaryTech = data.find(x => x.AppointmentTypeID == technicianCodeTypeId).User;
        let startTime = data.find(x => x.AppointmentTypeID == technicianCodeTypeId).StartTime;
        let returnObject = { TechnicianName: "", StartTime: null };

        if (!CommonMethods.CheckNullOrUndefined(primaryTech, false)) {
          returnObject["TechnicianName"] = this.isNull(primaryTech.FirstName) + " " + this.isNull(primaryTech.LastName);
        }
        if (!CommonMethods.CheckNullOrUndefined(startTime, true)) {
          returnObject["StartTime"] = CommonMethods.Convert24HrsTo12Hrs(startTime, false);
        }
        return returnObject;
      }
    }
    return {};
  }
}
